import {ReactElement, useContext, useId} from "react";
import {useTranslation} from "react-i18next";
import {Tooltip} from "react-tooltip";
import {ChannelContext} from "../../../Contexts/ChannelContext";
import {
    getMinimumOrderQuantity,
    isMinimumOrderQuantityEnabled,
    MinimumOrderQuantityProduct
} from "./getMinimumOrderQuantity";

type MinimumOrderQuantityProps = {
    product: MinimumOrderQuantityProduct;
};

export function MinimumOrderQuantity({product}: MinimumOrderQuantityProps): ReactElement | null {
    const {t} = useTranslation();
    const channel = useContext(ChannelContext);
    const minimumOrderQuantity = getMinimumOrderQuantity(product, channel);

    if (minimumOrderQuantity === null) {
        return null;
    }

    return (
        <div className="minimum-order-quantity">
            <span>{t('products-list.min-order-quantity')}:</span>
            <span>{minimumOrderQuantity}</span>
        </div>
    );
}

export function PackageMinimumOrderQuantity({product}: MinimumOrderQuantityProps): ReactElement {
    const channel = useContext(ChannelContext);
    const minimumOrderQuantity = getMinimumOrderQuantity(product, channel);

    if (minimumOrderQuantity === null) {
        return <>{product.quantityPackage}</>;
    }

    return <>{product.quantityPackage} / <strong className="minimum-order-quantity-value">{minimumOrderQuantity}</strong></>;
}

export function PackageMinimumOrderQuantityHeader(): ReactElement {
    const {t} = useTranslation();
    const channel = useContext(ChannelContext);

    if (!isMinimumOrderQuantityEnabled(channel)) {
        return <>{t('products-list.method-packing')}</>;
    }

    return <>{t('products-list.method-packing')} / <strong className="minimum-order-quantity-label">{t('products-list.min-order-quantity')}</strong></>;
}

export function MinimumOrderQuantityAdjustmentInfo(): ReactElement {
    const {t} = useTranslation();
    const tooltipId = useId();

    return (
        <>
            <i
                className="fas fa-exclamation-circle minimum-order-quantity-adjustment"
                data-tooltip-id={tooltipId}
                aria-label={t('products-list.minimum-order-quantity-adjustment')}
            />
            <Tooltip id={tooltipId} className="tooltip-info">
                {t('products-list.minimum-order-quantity-adjustment')}
            </Tooltip>
        </>
    );
}
